import SkillCard from "../components/SkillCard";
import Title from "../components/Title";
//skills
const lang = ["html", "css", "sass", "javascript"];
const library = [
  "react",
  "framer motion",
  "react router",
  "gsap",
  "bootstrap",
  "tailwind css",
];
const design = ["UI/UX", "figma", "adobe xd"];
const tool = ["git", "github", "wordpress", "elementor"];
function Skills() {
  return (
    <section className="relative my-24 lg:my-48" id="skills">
      {/* this div is just to have a fixed cotainer  */}
      <div className="el-container-lg ">
        {/* title */}
        <Title title="Skills" />
        {/* skills */}

        <div className="el-card-sec flex justify-between flex-wrap mt-2">
          <SkillCard skillTitle="Languages" skills={lang} />
          <SkillCard skillTitle="Libraries" skills={library} />
          <SkillCard skillTitle="Design" skills={design} />
          <SkillCard skillTitle="Platforms and Tools" skills={tool} />
        </div>
      </div>
    </section>
  );
}

export default Skills;
